import { EXTRA_GUARANTEE } from '~~/constants/productType';
import type { Cart } from '~~/types/commercetools';

export const getIsExtraGuaranteeOnlyCart = (cart: Cart) => {

  if (!cart?.lineItems || cart.lineItems.length === 0) {

    return false;
  
  }

  return cart.lineItems.every(
    (item) => item.productType?.key === EXTRA_GUARANTEE,
  );

};
